var React = require('react');

function IconChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#DA291C","stroke":"#DA291C","strokeWidth":".5","d":"M1.852 8.936l-.308-.357c-.073-.085-.073-.222 0-.307L4.351 5 1.544 1.728c-.073-.085-.073-.222 0-.307l.308-.358c.072-.084.19-.084.263 0l3.253 3.784c.073.084.073.222 0 .306L2.115 8.937c-.073.084-.19.084-.263 0z"}));
}

IconChevronInline.defaultProps = {"width":"7","height":"10","viewBox":"0 0 7 10"};

module.exports = IconChevronInline;

IconChevronInline.default = IconChevronInline;
